export default __webpack_public_path__ + "static/media/large-double-circle.6dd076fa.svg";